import { useState, useEffect } from "react";
import { getTenant, getUserName } from "./helpers";
import { api } from "./utils";

const useDocument = (username) => {
    const [documents, setDocuments] = useState([]);
    const [links, setLinks] = useState([]); 
    const [documentsDataLoaded, setDocumentsDataLoaded] = useState(false);

    useEffect(() => {
      const DEFAULT_TENANT_TO_USE = process.env.REACT_APP_IBL_PROFILE_RESUME_FEATURE_TENANT_TO_USE_WITH_ENDPOINTS ?? getTenant()
        api.ibldmplatform.getUserResume(
    
            { org: DEFAULT_TENANT_TO_USE, userID: username },
            (data) => {
                setDocuments(data?.files || []);
                setLinks(data?.links || []);
                setDocumentsDataLoaded(true);
            },
            (error) => {
                setDocumentsDataLoaded(true);
                setDocuments([]);
            }
        );
    }, [username]);

    return {
      documents,
      documentsDataLoaded,
      setDocuments,
      setDocumentsDataLoaded,
      links,
      setLinks,
    };
};

export default useDocument;